import React from 'react';
import { useLocation } from 'react-router-dom';
import PositionList from '../components/PositionList';
import { usePortfolioContext } from '../contexts/PortfolioContext';
import PortfolioRequired from '../components/PortfolioRequired';

const PositionsPage = () => {
  const { currentPortfolioId } = usePortfolioContext();
  const location = useLocation();
  // Debug navigation state
  if (location?.state) {
    // eslint-disable-next-line no-console
    console.log('PositionsPage navigation state:', location.state);
  }
  if (!currentPortfolioId) {
    return <PortfolioRequired title="Positions" description="Please select a portfolio to view positions." />;
  }
  return (
    <div className="px-2 sm:px-3 lg:px-4 py-2">
      <PositionList navState={location?.state} />
    </div>
  );
};

export default PositionsPage;
